import React from 'react';

import { Col } from '@components/formStyles';
import CustomIcon from '@components/utils/CustomIcon';
import { DeleteBin5Line } from '@assets/icons';
import { optimizeImage } from '@utils/imageOptimization';

import {
  DeleteButton,
  DynamicRow,
  Line,
  RoomDescription,
  RoomImage,
  RoomText,
  RoomTitle,
  RoomType,
  SelectedVariationsWrapper,
} from './styled';
import { SelectedVariationProps } from '../../context/types';
import { useHotelDetailState, useSetSelectedVariations } from '../../context';

const SelectedVariation = ({
  variation,
}: {
  variation: SelectedVariationProps;
}) => {
  const { selectedVariations } = useHotelDetailState();
  const setSelectedVariations = useSetSelectedVariations();
  return (
    <SelectedVariationsWrapper key={variation.tabNumber}>
      <DynamicRow>
        <RoomText>{variation.tabNumber}. Oda</RoomText>
        <Line />
        {variation.room?.image ? (
          <RoomImage
            alt='Oda Görseli'
            src={optimizeImage(variation.room?.image, '56', '56')}
          />
        ) : null}
        <Col>
          <RoomTitle>{variation.boardTypeName}</RoomTitle>
          <DynamicRow>
            <RoomDescription>
              {variation?.guests?.adultCount
                ? `${variation?.guests?.adultCount} Yetişkin`
                : ''}{' '}
              {variation?.guests?.childrenBirthDates?.length
                ? `${variation?.guests?.childrenBirthDates?.length} Çocuk`
                : ''}
            </RoomDescription>
            {variation?.room?.detail ? (
              <RoomType>{variation.room.detail}</RoomType>
            ) : null}
            {variation?.boardTypeName ? (
              <RoomType>{variation.boardTypeName}</RoomType>
            ) : null}
          </DynamicRow>
        </Col>
      </DynamicRow>
      <DeleteButton
        onClick={() =>
          setSelectedVariations(
            selectedVariations.filter(
              (room) => room.variationId !== variation.variationId
            )
          )
        }
      >
        <CustomIcon
          icon={DeleteBin5Line}
          fontSize={24}
          paletteColor='grey800'
        />
      </DeleteButton>
    </SelectedVariationsWrapper>
  );
};

export default SelectedVariation;
